export default "__VITE_ASSET__GRIJAauv__"